// Snyk security scan required for new/modified code. Ensure to run Snyk after changes.
// Temporary load API for seller/brand store
// These are for demonstration and should be replaced with actual store logic
// Usage: tempLoadSellerStore(payload), tempLoadBrandStore(payload)
// store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { secureStorage } from "./secureStorage";
import { cookieSyncMiddleware } from "./cookieSync";


import authReducer from "./authSlice";
import cartReducer from "./cartSlice";
import wishlistReducer from "./wishlistSlice";
import apiCountsReducer from "./apiCountsSlice";
import uiReducer from "./uiSlice";
// Temporary load API for seller/brand store
import { loadSellerStore, loadBrandStore } from "../api/loadStoreApi";


const rootReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
  apiCounts: apiCountsReducer,
  // Not persisted (absent from the whitelist below): modals/drawers start closed.
  ui: uiReducer,
});

// Example usage of temporary load API (for demonstration)
// Remove or replace with actual store logic as needed
export const tempLoadSellerStore = async (payload: unknown) => {
  return await loadSellerStore(payload);
};

export const tempLoadBrandStore = async (payload: unknown) => {
  return await loadBrandStore(payload);
};

const persistConfig = {
  key: "root",
  version: 1,
  storage: secureStorage,
  whitelist: ["auth", "cart", "wishlist", "apiCounts"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

type Store = ReturnType<typeof configureStore>;

export const store: Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: false,
    }).concat(cookieSyncMiddleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

